(function () {
  var APP_FORM_SELECTOR = '.application-page__form-app';
  var INLINE_FORM_ROOT_SELECTOR = '[data-form-root="true"][data-forms-id^="forms-root-"]';
  var INLINE_EMBED_SELECTOR = [
    'shopify-forms-embed',
    'shopify-forms-embed-dev',
    'shopify-forms-embed-staging',
    'shopify-forms-embed-staging-2',
    'shopify-forms-embed-staging-3',
    'shopify-forms-embed-staging-4'
  ].join(',');
  var POPUP_EMBED_SELECTOR = [
    '[id^="app-embed-container-"]',
    'shopify-forms-embed[id^="app-embed-container-"]',
    'shopify-forms-embed-dev[id^="app-embed-container-"]',
    'shopify-forms-embed-staging[id^="app-embed-container-"]',
    'shopify-forms-embed-staging-2[id^="app-embed-container-"]',
    'shopify-forms-embed-staging-3[id^="app-embed-container-"]',
    'shopify-forms-embed-staging-4[id^="app-embed-container-"]'
  ].join(',');

  var CUSTOM_FORM_SELECTOR = '[data-custom-application-form]';
  var DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
  var DAY_LABELS = {
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun'
  };

  var INLINE_FORM_THEME = {
    textColor: '#EAF5FF',
    buttonBackgroundColor: '#2D7BA8',
    buttonLabelColor: '#FFFFFF',
    linksColor: '#84D6FF',
    errorsColor: '#FF8A8A',
    textAlignment: 'left',
    alignment: 'left',
    fullWidth: 'true'
  };

  var INLINE_FORM_CSS_VARS = {
    '--inline-form-alignment': 'stretch',
    '--inline-container-max-width': '100%',
    '--container-max-w': '100%',
    '--container-text-alignment': 'left',
    '--container-border-radius': '20px',
    '--container-background-color': 'rgba(7, 26, 42, 0.66)',
    '--container-shadow': '0 10px 48px rgba(0, 0, 0, 0.42), inset 0 0 0 1px rgba(132, 214, 255, 0.1)',
    '--forms-padding-top': '0px',
    '--forms-padding-right': '0px',
    '--forms-padding-bottom': '0px',
    '--forms-padding-left': '0px',
    '--heading-text-color': 'rgba(240, 248, 255, 0.98)',
    '--body-text-color': 'rgba(214, 229, 240, 0.84)',
    '--link-text-color': '#84D6FF',
    '--form-text-color': 'rgba(234, 245, 255, 0.96)',
    '--form-placeholder-color': 'rgba(214, 229, 240, 0.58)',
    '--form-background-color': 'rgba(12, 25, 40, 0.7)',
    '--form-field-border': '0 0 0 1px rgba(126, 153, 176, 0.34)',
    '--form-field-border-focused': '0 0 0 2px rgba(65, 164, 214, 0.75)',
    '--form-field-border-radius': '10px',
    '--form-field-padding': '12px',
    '--form-error-color': '#FF8A8A',
    '--forms-accent-color': '#41A4D6',
    '--forms-accent-color-hovered-modifier': 'rgba(65, 164, 214, 0.14)',
    '--button-background-color': '#2D7BA8',
    '--button-text-color': '#FFFFFF',
    '--button-border': '0 solid transparent',
    '--button-border-radius': '14px',
    '--button-padding': '14px',
    '--button-close-background-color': 'rgba(12, 25, 40, 0.92)',
    '--button-close-color': '#EAF5FF'
  };

  function applyInlineThemeAttributes(root) {
    if (!root || !root.setAttribute) return;
    root.setAttribute('data-forms-text-color', INLINE_FORM_THEME.textColor);
    root.setAttribute('data-forms-button-background-color', INLINE_FORM_THEME.buttonBackgroundColor);
    root.setAttribute('data-forms-button-label-color', INLINE_FORM_THEME.buttonLabelColor);
    root.setAttribute('data-forms-links-color', INLINE_FORM_THEME.linksColor);
    root.setAttribute('data-forms-errors-color', INLINE_FORM_THEME.errorsColor);
    root.setAttribute('data-forms-text-alignment', INLINE_FORM_THEME.textAlignment);
    root.setAttribute('data-forms-alignment', INLINE_FORM_THEME.alignment);
    root.setAttribute('data-forms-full-width', INLINE_FORM_THEME.fullWidth);
    root.setAttribute('data-forms-padding-top', '0');
    root.setAttribute('data-forms-padding-right', '0');
    root.setAttribute('data-forms-padding-bottom', '0');
    root.setAttribute('data-forms-padding-left', '0');
  }

  function applyInlineThemeVars(node) {
    if (!node || !node.style || !node.style.setProperty) return;
    Object.keys(INLINE_FORM_CSS_VARS).forEach(function (key) {
      node.style.setProperty(key, INLINE_FORM_CSS_VARS[key]);
    });
  }

  function getInlineEmbeds(scope) {
    var embeds = [];
    if (!scope || scope.nodeType !== 1) return embeds;
    if (scope.matches && scope.matches(INLINE_EMBED_SELECTOR)) {
      embeds.push(scope);
    }
    if (scope.querySelectorAll) {
      scope.querySelectorAll(INLINE_EMBED_SELECTOR).forEach(function (embed) {
        embeds.push(embed);
      });
    }
    return embeds;
  }

  function applyInlineThemeToRoot(root) {
    if (!root || !root.querySelectorAll) return;
    applyInlineThemeAttributes(root);
    applyInlineThemeVars(root);

    var embeds = getInlineEmbeds(root);
    embeds.forEach(function (embed) {
      applyInlineThemeVars(embed);
      embed.style.display = 'block';
      embed.style.width = '100%';
      embed.style.maxWidth = '100%';
    });
  }

  function hidePopupEmbedNode(node) {
    if (!node || !node.style) return;
    node.style.display = 'none';
    node.style.visibility = 'hidden';
    node.style.opacity = '0';
    node.style.pointerEvents = 'none';
    node.setAttribute('hidden', 'hidden');
    node.setAttribute('aria-hidden', 'true');
  }

  function suppressPopupEmbeds(scope) {
    if (!scope || !scope.querySelectorAll) return;
    if (scope.matches && scope.matches(POPUP_EMBED_SELECTOR)) {
      hidePopupEmbedNode(scope);
    }
    scope.querySelectorAll(POPUP_EMBED_SELECTOR).forEach(hidePopupEmbedNode);
  }

  function initInlineForms(scope) {
    var elementScope = scope && scope.nodeType === 1 ? scope : document;

    var inlineRoots = [];
    if (elementScope.matches && elementScope.matches(INLINE_FORM_ROOT_SELECTOR)) {
      inlineRoots.push(elementScope);
    }
    if (elementScope.querySelectorAll) {
      elementScope.querySelectorAll(INLINE_FORM_ROOT_SELECTOR).forEach(function (root) {
        inlineRoots.push(root);
      });
    }

    inlineRoots.forEach(applyInlineThemeToRoot);

    var appHosts = document.querySelectorAll(APP_FORM_SELECTOR);
    appHosts.forEach(function (host) {
      getInlineEmbeds(host).forEach(function (embed) {
        applyInlineThemeVars(embed);
      });
    });

    suppressPopupEmbeds(document);
  }

  function formatPhone(raw) {
    var value = String(raw || '').replace(/\D/g, '').slice(0, 10);
    if (value.length >= 7) {
      return '(' + value.slice(0, 3) + ') ' + value.slice(3, 6) + '-' + value.slice(6);
    }
    if (value.length >= 4) {
      return '(' + value.slice(0, 3) + ') ' + value.slice(3);
    }
    return value;
  }

  function readFileAsBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        var result = String(reader.result || '');
        var comma = result.indexOf(',');
        resolve(comma >= 0 ? result.slice(comma + 1) : result);
      };
      reader.onerror = function () {
        reject(new Error('Failed to read resume file.'));
      };
      reader.readAsDataURL(file);
    });
  }

  function cloneAvailability(state) {
    var next = {};
    Object.keys(state).forEach(function (day) {
      next[day] = state[day].slice();
    });
    return next;
  }

  function toggleAvailability(state, day, slot) {
    var next = cloneAvailability(state);
    var slots = next[day] ? next[day].slice() : [];

    if (slot === 'all') {
      var hasAll = slots.indexOf('all') >= 0;
      if (hasAll) {
        delete next[day];
      } else {
        next[day] = ['all', 'am', 'pm'];
      }
      return next;
    }

    var idx = slots.indexOf(slot);
    if (idx >= 0) {
      slots.splice(idx, 1);
    } else {
      slots.push(slot);
    }

    var hasAm = slots.indexOf('am') >= 0;
    var hasPm = slots.indexOf('pm') >= 0;
    var allIdx = slots.indexOf('all');

    if (hasAm && hasPm && allIdx < 0) {
      slots.push('all');
    }
    if ((!hasAm || !hasPm) && allIdx >= 0) {
      slots.splice(allIdx, 1);
    }

    if (slots.length === 0) {
      delete next[day];
    } else {
      next[day] = slots;
    }

    return next;
  }

  function availabilityStatusText(state) {
    var dayCount = Object.keys(state).length;
    var slotCount = Object.keys(state).reduce(function (total, day) {
      return total + (state[day] ? state[day].length : 0);
    }, 0);

    if (slotCount === 0) {
      return 'No hours selected yet.';
    }

    return dayCount + ' day' + (dayCount === 1 ? '' : 's') + ' selected (' + slotCount + ' total time blocks).';
  }

  function availabilityForSheet(state) {
    var lines = [];
    DAYS.forEach(function (day) {
      var slots = state[day] || [];
      lines.push(DAY_LABELS[day] + ': ' + (slots.length ? slots.join(', ') : 'none'));
    });
    return lines.join(' | ');
  }

  function setInvalid(field, invalid) {
    if (!field || !field.setAttribute) return;
    if (invalid) {
      field.setAttribute('aria-invalid', 'true');
    } else {
      field.removeAttribute('aria-invalid');
    }
  }

  function showFormError(form, message) {
    var errorBox = form.parentElement.querySelector('[data-form-errors]');
    if (!errorBox) return;
    errorBox.textContent = message;
    errorBox.hidden = false;
  }

  function clearFormError(form) {
    var errorBox = form.parentElement.querySelector('[data-form-errors]');
    if (!errorBox) return;
    errorBox.hidden = true;
    errorBox.textContent = '';
  }

  function showFormSuccess(form) {
    var successBox = form.parentElement.querySelector('[data-form-success]');
    if (!successBox) return;
    successBox.hidden = false;
  }

  function clearFormSuccess(form) {
    var successBox = form.parentElement.querySelector('[data-form-success]');
    if (!successBox) return;
    successBox.hidden = true;
  }

  function resolveUploadEndpoint(form) {
    var configured = String(form.dataset.uploadEndpoint || '').trim();
    if (configured) return configured;

    try {
      var urlParams = new URLSearchParams(window.location.search);
      var endpointFromUrl = String(urlParams.get('upload_endpoint') || '').trim();
      if (endpointFromUrl) {
        form.dataset.uploadEndpoint = endpointFromUrl;
        return endpointFromUrl;
      }
    } catch (error) {
      // Ignore URL parsing issues and keep endpoint empty.
    }

    return '';
  }

  function syncEndpointUi(form) {
    var endpointWarning = form.querySelector('[data-upload-endpoint-warning]');
    if (!endpointWarning) return;
    endpointWarning.hidden = !!resolveUploadEndpoint(form);
  }

  function syncUploadUi(form, file) {
    var dropzone = form.querySelector('[data-upload-dropzone]');
    var title = form.querySelector('[data-upload-title]');
    var meta = form.querySelector('[data-upload-meta]');
    var clearButton = form.querySelector('[data-upload-clear]');

    if (!dropzone || !title || !meta || !clearButton) return;

    if (file) {
      dropzone.classList.add('has-file');
      title.textContent = file.name;
      meta.textContent = (file.size / (1024 * 1024)).toFixed(1) + ' MB';
      clearButton.hidden = false;
    } else {
      dropzone.classList.remove('has-file');
      title.textContent = 'Upload Resume';
      meta.textContent = 'PDF, DOC, DOCX - Max 5MB';
      clearButton.hidden = true;
    }
  }

  function updateAvailabilityUi(form, state) {
    var status = form.querySelector('[data-availability-status]');
    var hiddenInput = form.querySelector('[data-availability-input]');

    if (status) {
      status.textContent = availabilityStatusText(state);
    }

    if (hiddenInput) {
      hiddenInput.value = JSON.stringify(state);
    }

    var pills = form.querySelectorAll('[data-day][data-slot]');
    pills.forEach(function (pill) {
      var day = pill.getAttribute('data-day');
      var slot = pill.getAttribute('data-slot');
      var slots = state[day] || [];
      var active = slots.indexOf(slot) >= 0;
      pill.classList.toggle('is-active', active);
      pill.textContent = active ? 'Available' : 'Not Available';
      pill.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function initCustomForm(form) {
    if (!form || form.dataset.customFormInit === 'true') return;
    form.dataset.customFormInit = 'true';

    var phoneField = form.querySelector('#application-phone');
    var firstNameField = form.querySelector('#application-first-name');
    var lastNameField = form.querySelector('#application-last-name');
    var emailField = form.querySelector('#application-email');
    var positionField = form.querySelector('#application-position');
    var socialField = form.querySelector('#application-social');
    var resumeInput = form.querySelector('[data-resume-input]');
    var submitButton = form.querySelector('[data-submit-button]');

    var availability = {};
    updateAvailabilityUi(form, availability);
    syncUploadUi(form, null);
    syncEndpointUi(form);

    function resetFormAfterSubmit() {
      form.reset();
      availability = {};
      updateAvailabilityUi(form, availability);
      syncUploadUi(form, null);
      [firstNameField, lastNameField, phoneField, emailField, positionField, socialField, resumeInput].forEach(function (field) {
        setInvalid(field, false);
      });
    }

    if (phoneField) {
      phoneField.addEventListener('input', function () {
        phoneField.value = formatPhone(phoneField.value);
        setInvalid(phoneField, false);
      });
    }

    [firstNameField, lastNameField, emailField, positionField, socialField].forEach(function (field) {
      if (!field) return;
      field.addEventListener('input', function () {
        setInvalid(field, false);
      });
    });

    var pills = form.querySelectorAll('[data-day][data-slot]');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var day = pill.getAttribute('data-day');
        var slot = pill.getAttribute('data-slot');
        availability = toggleAvailability(availability, day, slot);
        updateAvailabilityUi(form, availability);
      });
    });

    if (resumeInput) {
      resumeInput.addEventListener('change', function () {
        var file = resumeInput.files && resumeInput.files[0] ? resumeInput.files[0] : null;
        syncUploadUi(form, file);
        setInvalid(resumeInput, false);
      });
    }

    var dropzone = form.querySelector('[data-upload-dropzone]');
    if (dropzone && resumeInput) {
      dropzone.addEventListener('dragover', function (event) {
        event.preventDefault();
      });

      dropzone.addEventListener('drop', function (event) {
        event.preventDefault();
        var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
        if (!file) return;

        var dt = new DataTransfer();
        dt.items.add(file);
        resumeInput.files = dt.files;
        syncUploadUi(form, file);
        setInvalid(resumeInput, false);
      });
    }

    var clearButton = form.querySelector('[data-upload-clear]');
    if (clearButton && resumeInput) {
      clearButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        resumeInput.value = '';
        syncUploadUi(form, null);
      });
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      clearFormError(form);
      clearFormSuccess(form);

      var endpoint = resolveUploadEndpoint(form);
      if (!endpoint) {
        showFormError(form, 'Resume uploads are not connected yet. In Theme Editor, open this section and set "Apps Script upload endpoint URL".');
        return;
      }

      var requiredFields = [firstNameField, lastNameField, phoneField, emailField];
      var hasErrors = false;
      requiredFields.forEach(function (field) {
        if (!field) return;
        var invalid = !String(field.value || '').trim();
        setInvalid(field, invalid);
        if (invalid) hasErrors = true;
      });

      var file = resumeInput && resumeInput.files && resumeInput.files[0] ? resumeInput.files[0] : null;
      if (!file) {
        setInvalid(resumeInput, true);
        hasErrors = true;
      }

      if (hasErrors) {
        showFormError(form, 'Please complete all required fields and attach a resume.');
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        setInvalid(resumeInput, true);
        showFormError(form, 'Resume must be under 5MB.');
        return;
      }

      var originalSubmitText = submitButton ? submitButton.textContent : 'Submit Application';
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Submitting...';
      }

      try {
        var payload = {
          first_name: String(firstNameField && firstNameField.value || '').trim(),
          last_name: String(lastNameField && lastNameField.value || '').trim(),
          phone: String(phoneField && phoneField.value || '').trim(),
          email: String(emailField && emailField.value || '').trim(),
          position: String(positionField && positionField.value || '').trim(),
          social: String(socialField && socialField.value || '').trim(),
          availability: availabilityForSheet(availability),
          notes: 'Application source: Shopify custom form'
        };

        var uploadToken = String(form.dataset.uploadToken || '').trim();
        var spreadsheetId = String(form.dataset.spreadsheetId || '').trim();

        if (uploadToken) payload.token = uploadToken;
        if (spreadsheetId) payload.spreadsheet_id = spreadsheetId;

        payload.file_name = file.name;
        payload.resume_name = file.name;
        payload.mime_type = file.type || 'application/octet-stream';
        payload.base64_data = await readFileAsBase64(file);

        var response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'text/plain;charset=utf-8'
          },
          body: JSON.stringify(payload)
        });

        var responseJson = null;
        try {
          responseJson = await response.json();
        } catch (error) {
          responseJson = null;
        }

        if (!response.ok) {
          throw new Error('Upload endpoint returned HTTP ' + response.status + '.');
        }

        if (responseJson && responseJson.success === false) {
          throw new Error(responseJson.error || 'Upload endpoint rejected the application.');
        }

        resetFormAfterSubmit();
        showFormSuccess(form);
      } catch (error) {
        var message = error && error.message ? error.message : 'Something went wrong. Please try again.';
        if (message.toLowerCase() === 'failed to fetch') {
          message = 'Cannot reach upload endpoint. Check the Apps Script URL and make sure the web app is deployed with access set to Anyone.';
        }
        showFormError(form, message);
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalSubmitText;
        }
      }
    });
  }

  function initCustomForms(scope) {
    var elementScope = scope && scope.nodeType === 1 ? scope : document;
    var forms = [];

    if (elementScope.matches && elementScope.matches(CUSTOM_FORM_SELECTOR)) {
      forms.push(elementScope);
    }

    if (elementScope.querySelectorAll) {
      elementScope.querySelectorAll(CUSTOM_FORM_SELECTOR).forEach(function (form) {
        forms.push(form);
      });
    }

    forms.forEach(initCustomForm);
  }

  function observeMutations() {
    if (document.documentElement.dataset.applicationInlineObserverInit === 'true') return;
    document.documentElement.dataset.applicationInlineObserverInit = 'true';

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          initInlineForms(node);
          initCustomForms(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function runInitialSyncLoop() {
    var runs = 0;
    var maxRuns = 20;
    var timer = window.setInterval(function () {
      runs += 1;
      initInlineForms(document);
      initCustomForms(document);
      if (runs >= maxRuns) {
        window.clearInterval(timer);
      }
    }, 500);
  }

  function init(root) {
    initInlineForms(root || document);
    initCustomForms(root || document);
    observeMutations();
    runInitialSyncLoop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
